/* Aliénore · apparitions douces et choix de l'initiale */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.aln-reveal:not(.is-in)');
    if (reduce || document.hidden || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  function letters() {
    document.querySelectorAll('.aln-letters:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      var img = sec.querySelector('.aln-letters__img');
      var big = sec.querySelector('[data-aln-letters-big]');
      if (!img) return;
      var cache = {};
      function show(key) {
        var src = key.getAttribute('data-img');
        var letter = key.getAttribute('data-letter');
        sec.querySelectorAll('.aln-letters__key.is-active').forEach(function (k) { k.classList.remove('is-active'); });
        key.classList.add('is-active');
        if (big) big.textContent = letter;
        if (!src || img.getAttribute('src') === src) return;
        img.classList.add('is-swapping');
        var pre = cache[src] || (cache[src] = new Image());
        if (!pre.src) pre.src = src;
        var done = function () { img.removeAttribute('srcset'); img.src = src; img.classList.remove('is-swapping'); };
        if (pre.complete) done(); else pre.onload = done;
      }
      sec.querySelectorAll('.aln-letters__key').forEach(function (key) {
        key.addEventListener('mouseenter', function () { show(key); });
        key.addEventListener('focus', function () { show(key); });
      });
    });
  }

  function offer() {
    document.querySelectorAll('.aln-offer-src:not([data-ready])').forEach(function (src) {
      src.setAttribute('data-ready', '');
      var info = src.closest('.product__info-container') || document;
      var price = info.querySelector('.product-page-price');
      if (!price || !price.parentNode) return;
      var row = document.createElement('div');
      row.className = 'aln-price-row';
      price.parentNode.insertBefore(row, price);
      row.appendChild(price);
      var badge = src.querySelector('.aln-offer');
      if (badge) row.appendChild(badge);
      src.remove();
    });
  }

  function init() { reveal(); letters(); offer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
